/* eslint-disable */
// @generated

export enum AioRelevantArticleLinkTypeEnum {
  External = 'EXTERNAL',
  InternalArticle = 'INTERNAL_ARTICLE',
  InternalPage = 'INTERNAL_PAGE'
}

export enum AmountFilterStyle {
  Calculated = 'Calculated',
  DirectEntry = 'DirectEntry',
  Slider = 'Slider'
}

export enum ApplicationState {
  Complete = 'COMPLETE',
  Error = 'ERROR',
  InProgress = 'IN_PROGRESS',
  Reject = 'REJECT',
  Success = 'SUCCESS'
}

/** List of Application Status */
export enum ApplicationStatus {
  Error = 'ERROR',
  Paid = 'PAID',
  Pending = 'PENDING',
  Submitted = 'SUBMITTED',
  Success = 'SUCCESS'
}

/** Approval degree level for credit products */
export enum ApprovalDegree {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
  Unknown = 'UNKNOWN'
}

/** The format of the attribute, which determines how it is displayed and interacted with in the UI. */
export enum AttributeFormatEnum {
  AddOn = 'ADD_ON',
  Boolean = 'BOOLEAN',
  DropdownSelection = 'DROPDOWN_SELECTION',
  Json = 'JSON',
  KeyValueText = 'KEY_VALUE_TEXT',
  Number = 'NUMBER',
  NumberRange = 'NUMBER_RANGE',
  PlainText = 'PLAIN_TEXT',
  RateCi = 'RATE_CI',
  RateTable = 'RATE_TABLE',
  RichTextEditor = 'RICH_TEXT_EDITOR',
  Table = 'TABLE'
}

export enum AttributesListStyleEnum {
  Highlight = 'HIGHLIGHT',
  Regular = 'REGULAR',
  Strong = 'STRONG',
  StrongColour = 'STRONG_COLOUR'
}

export enum AudienceEnum {
  All = 'ALL',
  LoggedIn = 'LOGGED_IN',
  LoggedOut = 'LOGGED_OUT'
}

export enum CallToActionColorSchemeEnum {
  Blue = 'BLUE',
  Green = 'GREEN',
  Orange = 'ORANGE',
  Red = 'RED',
  Transparent = 'TRANSPARENT',
  White = 'WHITE',
  Yellow = 'YELLOW'
}

export enum CampaingColorEnum {
  Blue = 'BLUE',
  Green = 'GREEN',
  Orange = 'ORANGE',
  Red = 'RED',
  Yellow = 'YELLOW'
}

/** Defines the type of button for car insurance product components. */
export enum CarInsuranceProductComponentButtonTypeEnum {
  Cta = 'CTA',
  Neutral = 'NEUTRAL',
  NeutralLightAndBlue = 'NEUTRAL_LIGHT_AND_BLUE',
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY'
}

/** Car type */
export enum CarType {
  Grab = 'GRAB',
  Pc1 = 'PC1',
  Pc2 = 'PC2'
}

/** List of Carrier Code */
export enum CarrierCode {
  Allianz = 'ALLIANZ',
  Alliedworld = 'ALLIEDWORLD',
  Blcr = 'BLCR',
  Bolttech = 'BOLTTECH',
  Dsi = 'DSI',
  Etiqa = 'ETIQA',
  Fwd = 'FWD',
  Generali = 'GENERALI',
  Hlas = 'HLAS',
  Mhallianz = 'MHALLIANZ',
  Mhbolttech = 'MHBOLTTECH',
  Mhgenerali = 'MHGENERALI',
  Msig = 'MSIG',
  Qbe = 'QBE',
  Ssallianz = 'SSALLIANZ',
  Sshlas = 'SSHLAS',
  Sszurich = 'SSZURICH',
  Starr = 'STARR',
  Zurich = 'ZURICH'
}

/** Filter group a category identifier belongs to. NONE means the tag is not exposed as a filter option. */
export enum CategoryIdentifierFacetKind {
  Collection = 'COLLECTION',
  Feature = 'FEATURE',
  None = 'NONE',
  RewardType = 'REWARD_TYPE',
  SpendCategory = 'SPEND_CATEGORY'
}

export enum CcCardListingTrackingListNameEnum {
  ResultList = 'RESULT_LIST',
  SimilarCards = 'SIMILAR_CARDS',
  TrendingCards = 'TRENDING_CARDS'
}

export enum CcSortOptionValueEnum {
  AnnualFee = 'ANNUAL_FEE',
  GiftValue = 'GIFT_VALUE',
  MinimumAnnualIncome = 'MINIMUM_ANNUAL_INCOME',
  Trending = 'TRENDING'
}

export enum CiDrivingExperienceEnum {
  Year_0 = 'YEAR_0',
  Year_1 = 'YEAR_1',
  Year_2 = 'YEAR_2',
  Year_3 = 'YEAR_3',
  Year_4 = 'YEAR_4',
  Year_5AndAbove = 'YEAR_5_AND_ABOVE'
}

export enum CiGenderEnum {
  Female = 'FEMALE',
  Male = 'MALE'
}

export enum CiMaritalStatusEnum {
  Married = 'MARRIED',
  Single = 'SINGLE'
}

export enum CiOccupationTypeEnum {
  Indoor = 'INDOOR',
  Outdoor = 'OUTDOOR'
}

export enum CiPeakVehicleEnum {
  No = 'NO',
  Yes = 'YES'
}

export enum ColumnDefinitionTypeEnum {
  CatalogueAttribute = 'CATALOGUE_ATTRIBUTE',
  FreeText = 'FREE_TEXT',
  HotRewardPick = 'HOT_REWARD_PICK',
  PlTotalReward = 'PL_TOTAL_REWARD'
}

export enum ColumnSizingEnum {
  Fill = 'FILL',
  L = 'L',
  M = 'M',
  S = 'S'
}

export enum ComparisonEmptySelectionEnum {
  Prompt = 'PROMPT',
  ReturnToResults = 'RETURN_TO_RESULTS'
}

export enum ComparisonHighlightDirectionEnum {
  HigherBetter = 'HIGHER_BETTER',
  LowerBetter = 'LOWER_BETTER',
  None = 'NONE'
}

export enum ComparisonRowSourceEnum {
  Attribute = 'ATTRIBUTE',
  ExclusiveOffer = 'EXCLUSIVE_OFFER',
  WelcomeOffer = 'WELCOME_OFFER'
}

export enum ComparisonTableColumnKeyEnum {
  ApplyNowButton = 'APPLY_NOW_BUTTON',
  ApprovalOdds = 'APPROVAL_ODDS',
  BankLogo = 'BANK_LOGO',
  HotReward = 'HOT_REWARD',
  ProductName = 'PRODUCT_NAME',
  RewardValue = 'REWARD_VALUE'
}

/** Annual-fee band. Bands are independent statements, not a precedence chain: a waived card with a stated fee carries its waiver band and its paid tier. */
export enum CreditCardAnnualFeeBand {
  FirstYearWaived = 'FIRST_YEAR_WAIVED',
  FreeForever = 'FREE_FOREVER',
  PaidTier_1 = 'PAID_TIER_1',
  PaidTier_2 = 'PAID_TIER_2',
  PaidTier_3 = 'PAID_TIER_3'
}

/** Minimum-annual-income band. NO_REQUIREMENT also covers cards whose income value is absent or unparseable. */
export enum CreditCardIncomeBand {
  IncomeTier_1 = 'INCOME_TIER_1',
  IncomeTier_2 = 'INCOME_TIER_2',
  IncomeTier_3 = 'INCOME_TIER_3',
  IncomeTier_4 = 'INCOME_TIER_4',
  IncomeTier_5 = 'INCOME_TIER_5',
  NoRequirement = 'NO_REQUIREMENT'
}

/** Payment network a credit card runs on. JCB is declared but carries no cards until content records it. */
export enum CreditCardNetwork {
  Amex = 'AMEX',
  Jcb = 'JCB',
  Mastercard = 'MASTERCARD',
  Unionpay = 'UNIONPAY',
  Visa = 'VISA'
}

export enum CtaButtonStyleTypeEnum {
  Cta = 'CTA',
  Neutral = 'NEUTRAL',
  NeutralLightAndBlue = 'NEUTRAL_LIGHT_AND_BLUE',
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY'
}

export enum CtaButtonVariantEnum {
  Filled = 'FILLED',
  Outline = 'OUTLINE',
  Text = 'TEXT'
}

export enum CtaSectionBlockBackgroundThemeEnum {
  Alternative_1 = 'ALTERNATIVE_1',
  Alternative_2 = 'ALTERNATIVE_2',
  Alternative_3 = 'ALTERNATIVE_3',
  PrimaryLight = 'PRIMARY_LIGHT',
  SecondaryLight = 'SECONDARY_LIGHT'
}

export enum CtaSectionBlockTextAlignEnum {
  Center = 'CENTER',
  Left = 'LEFT'
}

export enum CustomerReviewsBlockAlignEnum {
  Center = 'CENTER',
  Left = 'LEFT'
}

export enum CustomerReviewsBlockBgColorVariantEnum {
  Alternative_1 = 'ALTERNATIVE_1',
  Alternative_2 = 'ALTERNATIVE_2',
  Alternative_3 = 'ALTERNATIVE_3',
  PrimaryLight = 'PRIMARY_LIGHT',
  SecondaryLight = 'SECONDARY_LIGHT'
}

export enum CustomerReviewsBlockReviewSourceEnum {
  GoogleReviews = 'GOOGLE_REVIEWS'
}

export enum DateFieldStyle {
  AfterToday = 'AFTER_TODAY',
  Any = 'ANY',
  BeforeToday = 'BEFORE_TODAY'
}

export enum DeliveryNoteStatusEnum {
  ManualUnderwriting = 'MANUAL_UNDERWRITING',
  Success = 'SUCCESS'
}

/** What an earn-rate row's `rate` is denominated in. */
export enum EarnRateKind {
  Cashback = 'CASHBACK',
  Miles = 'MILES',
  Points = 'POINTS'
}

/** Spend scope an earn-rate row applies to. */
export enum EarnRateScope {
  Local = 'LOCAL',
  Online = 'ONLINE',
  Overseas = 'OVERSEAS'
}

export enum EducationLevel {
  CompletedPrimary = 'COMPLETED_PRIMARY',
  CompletedSecondary = 'COMPLETED_SECONDARY',
  Degree = 'DEGREE',
  Diploma = 'DIPLOMA',
  GceALevel = 'GCE_A_LEVEL',
  GceOLevel = 'GCE_O_LEVEL',
  MatriculatedOrPostSecondary = 'MATRICULATED_OR_POST_SECONDARY',
  NotApplicable = 'NOT_APPLICABLE',
  OtherEducationLevel = 'OTHER_EDUCATION_LEVEL',
  PrimarySecondary = 'PRIMARY_SECONDARY',
  ProfessionalQualification = 'PROFESSIONAL_QUALIFICATION',
  TechnicalInstitute = 'TECHNICAL_INSTITUTE',
  UniversityOrAbove = 'UNIVERSITY_OR_ABOVE',
  VocationalQualification = 'VOCATIONAL_QUALIFICATION'
}

export enum EmploymentStatus {
  Director = 'DIRECTOR',
  Fulltime = 'FULLTIME',
  Housewife = 'HOUSEWIFE',
  OtherEmploymentStatus = 'OTHER_EMPLOYMENT_STATUS',
  Retired = 'RETIRED',
  SelfEmployed = 'SELF_EMPLOYED',
  Student = 'STUDENT',
  Unemployed = 'UNEMPLOYED'
}

export enum ExclusiveOfferBadgeColorEnum {
  Blue = 'BLUE',
  Gray = 'GRAY',
  Green = 'GREEN',
  Orange = 'ORANGE',
  Red = 'RED',
  Yellow = 'YELLOW'
}

/** How several selections inside one filter group combine. OR shows products matching any of them; AND shows only products matching all of them. */
export enum FilterCombinatorEnum {
  And = 'AND',
  Or = 'OR'
}

export enum FilterDisplayModeEnum {
  Checkbox = 'CHECKBOX',
  Chips = 'CHIPS'
}

export enum FilterTypeEnum {
  Offers = 'OFFERS',
  ProductAttributes = 'PRODUCT_ATTRIBUTES',
  ProductTags = 'PRODUCT_TAGS',
  Providers = 'PROVIDERS'
}

/** How a filter value is matched against the product attribute it points at. DEFINED needs no operand and matches when the attribute is present and not false, and NOT_DEFINED is its inverse — the only way to match a product that states nothing for the attribute; EQUALS, LESS_THAN and GREATER_THAN compare against `operand`; BETWEEN is the inclusive band from `operand` to `operandEnd`. */
export enum FilterValueOperatorEnum {
  Between = 'BETWEEN',
  Defined = 'DEFINED',
  Equals = 'EQUALS',
  GreaterThan = 'GREATER_THAN',
  LessThan = 'LESS_THAN',
  NotDefined = 'NOT_DEFINED'
}

export enum FilterValueSortingEnum {
  Alpha = 'ALPHA',
  Count = 'COUNT',
  Manual = 'MANUAL'
}

export enum FlexibleHeroBlockHeroTypeEnum {
  Campaign = 'CAMPAIGN',
  Cta = 'CTA',
  FormFieldAndImage = 'FORM_FIELD_AND_IMAGE',
  ImageOnly = 'IMAGE_ONLY',
  Product = 'PRODUCT',
  Provider = 'PROVIDER'
}

export enum FlexibleHeroBlockRewardTypeEnum {
  Carousel = 'CAROUSEL',
  Image = 'IMAGE',
  None = 'NONE'
}

export enum FlexibleHeroBlockTextAlignEnum {
  Center = 'CENTER',
  Left = 'LEFT'
}

export enum FlexibleHeroBlockThemeEnum {
  Dark = 'DARK',
  Light = 'LIGHT'
}

export enum FlowReason {
  BadValue = 'BAD_VALUE',
  Required = 'REQUIRED'
}

export enum FormatType {
  Dollar = 'DOLLAR',
  HkDollar = 'HK_DOLLAR',
  MilesPerSpend = 'MILES_PER_SPEND',
  PassThrough = 'PASS_THROUGH',
  Percentage = 'PERCENTAGE'
}

export enum FulfillmentState {
  /** Eligibility confirmed */
  Approved = 'APPROVED',
  /** Eligibility cannot be confirmed / declined by the financial institution */
  Declined = 'DECLINED',
  /** An Appeal Request is raised and pending for verification */
  Disputed = 'DISPUTED',
  /** An ARN is submitted in more than one redemption form */
  FoundMultiple = 'FOUND_MULTIPLE',
  /** No result was found */
  FoundNone = 'FOUND_NONE',
  /** Fulfilled */
  Fulfilled = 'FULFILLED',
  /** Pending (no general timeline) */
  Pending = 'PENDING',
  /** The application is pending for customer to provide the approval proof of the financial product */
  PendingProof = 'PENDING_PROOF',
  /** Received */
  Received = 'RECEIVED',
  /** TBC. */
  Tbc = 'TBC',
  /** Status is unknown or we just don't want to tell */
  Unknown = 'UNKNOWN'
}

export enum Gender {
  Female = 'FEMALE',
  Male = 'MALE'
}

/** Reward category a gift belongs to. NONE means the gift is not classified and must not be offered as a gift filter option. */
export enum GiftType {
  Apple = 'APPLE',
  Cash = 'CASH',
  Electronics = 'ELECTRONICS',
  Luggage = 'LUGGAGE',
  Miles = 'MILES',
  None = 'NONE',
  Trip = 'TRIP',
  Voucher = 'VOUCHER',
  Welcome = 'WELCOME'
}

export enum GridModuleAlignEnum {
  Center = 'CENTER',
  Left = 'LEFT'
}

export enum GridModuleBackgroundColorEnum {
  Alternative_1 = 'ALTERNATIVE_1',
  Alternative_2 = 'ALTERNATIVE_2',
  Alternative_3 = 'ALTERNATIVE_3',
  PrimaryLight = 'PRIMARY_LIGHT',
  SecondaryLight = 'SECONDARY_LIGHT'
}

export enum GridModuleWidthModeEnum {
  FullWidth = 'FULL_WIDTH',
  LeftAligned = 'LEFT_ALIGNED'
}

export enum HeaderWithTabsTabIconEnum {
  CarInsurance = 'CAR_INSURANCE',
  CreditCards = 'CREDIT_CARDS',
  HomeInsurance = 'HOME_INSURANCE',
  Investments = 'INVESTMENTS',
  MaidInsurance = 'MAID_INSURANCE',
  PersonalLoans = 'PERSONAL_LOANS',
  PriorityBanking = 'PRIORITY_BANKING',
  SavingAccounts = 'SAVING_ACCOUNTS',
  TravelInsurance = 'TRAVEL_INSURANCE'
}

export enum HeadingLevelEnum {
  Heading_2 = 'HEADING_2',
  Heading_3 = 'HEADING_3',
  Heading_4 = 'HEADING_4',
  Heading_5 = 'HEADING_5',
  Heading_6 = 'HEADING_6'
}

export enum Honorific {
  Dr = 'DR',
  Miss = 'MISS',
  Mr = 'MR',
  Mrs = 'MRS',
  Ms = 'MS'
}

export enum IconEnum {
  Award = 'AWARD',
  Bag = 'BAG',
  BigEqual = 'BIG_EQUAL',
  Cart = 'CART',
  Checklist = 'CHECKLIST',
  CreditCard = 'CREDIT_CARD',
  Money = 'MONEY',
  MoneyBox = 'MONEY_BOX',
  SearchShield = 'SEARCH_SHIELD',
  Wheel = 'WHEEL'
}

export enum IdentityDocumentType {
  Fin = 'FIN',
  Hkid = 'HKID',
  Nric = 'NRIC',
  Passport = 'PASSPORT',
  Twid = 'TWID'
}

export enum ImageAlignmentEnum {
  Center = 'CENTER',
  Left = 'LEFT',
  Right = 'RIGHT'
}

export enum ImageCarouselSlideClickTypeEnum {
  ApplyClick = 'APPLY_CLICK',
  NavigateClick = 'NAVIGATE_CLICK'
}

export enum ImageWidthEnum {
  Width_20Percent = 'WIDTH_20_PERCENT',
  Width_50Percent = 'WIDTH_50_PERCENT',
  Width_70Percent = 'WIDTH_70_PERCENT',
  Width_100Percent = 'WIDTH_100_PERCENT'
}

export enum Industry {
  AdvertisingPr = 'ADVERTISING_PR',
  AirlineCommercialAviation = 'AIRLINE_COMMERCIAL_AVIATION',
  AirCargoFreightForwarding = 'AIR_CARGO_FREIGHT_FORWARDING',
  Architecture = 'ARCHITECTURE',
  AuditingAccounting = 'AUDITING_ACCOUNTING',
  AutoIndustry = 'AUTO_INDUSTRY',
  BankingFinancialInstitutions = 'BANKING_FINANCIAL_INSTITUTIONS',
  Charity = 'CHARITY',
  ChemicalOilGas = 'CHEMICAL_OIL_GAS',
  CivilServices = 'CIVIL_SERVICES',
  ClothingGarmentTextile = 'CLOTHING_GARMENT_TEXTILE',
  CommodityBrokingHouses = 'COMMODITY_BROKING_HOUSES',
  EducationPrivateSchools = 'EDUCATION_PRIVATE_SCHOOLS',
  ElectricalEngineering = 'ELECTRICAL_ENGINEERING',
  Electronic = 'ELECTRONIC',
  EmploymentAgencies = 'EMPLOYMENT_AGENCIES',
  Energy = 'ENERGY',
  EngineeringOthers = 'ENGINEERING_OTHERS',
  EngineeringServicesAndWorks = 'ENGINEERING_SERVICES_AND_WORKS',
  EntertainmentBusiness = 'ENTERTAINMENT_BUSINESS',
  EnvironmentalScience = 'ENVIRONMENTAL_SCIENCE',
  FinancialServices = 'FINANCIAL_SERVICES',
  FnbRestaurantsHawkers = 'FNB_RESTAURANTS_HAWKERS',
  GeneralTradingDistributors = 'GENERAL_TRADING_DISTRIBUTORS',
  GovernmentBodies = 'GOVERNMENT_BODIES',
  HealthcareBeautyCentre = 'HEALTHCARE_BEAUTY_CENTRE',
  HoldingInvestmentCompanies = 'HOLDING_INVESTMENT_COMPANIES',
  HospitalityCatering = 'HOSPITALITY_CATERING',
  HotelResortCountryClubs = 'HOTEL_RESORT_COUNTRY_CLUBS',
  HumanResources = 'HUMAN_RESOURCES',
  InformationTechnology = 'INFORMATION_TECHNOLOGY',
  Insurance = 'INSURANCE',
  InteriorGraphicDesign = 'INTERIOR_GRAPHIC_DESIGN',
  ItSolutionProvidersWebDesign = 'IT_SOLUTION_PROVIDERS_WEB_DESIGN',
  Jewellery = 'JEWELLERY',
  Laboratory = 'LABORATORY',
  LandTransportMovers = 'LAND_TRANSPORT_MOVERS',
  Legal = 'LEGAL',
  ManagementConsultancy = 'MANAGEMENT_CONSULTANCY',
  Manufacturing = 'MANUFACTURING',
  MassTransportation = 'MASS_TRANSPORTATION',
  MediaPublishingCompany = 'MEDIA_PUBLISHING_COMPANY',
  MedicalDentalHospitalsClinics = 'MEDICAL_DENTAL_HOSPITALS_CLINICS',
  MedicalPharmaceutical = 'MEDICAL_PHARMACEUTICAL',
  Mnc = 'MNC',
  MotorVehicles = 'MOTOR_VEHICLES',
  OthersMiscAndForeignGovt = 'OTHERS_MISC_AND_FOREIGN_GOVT',
  PerformanceMusic = 'PERFORMANCE_MUSIC',
  PrintingServices = 'PRINTING_SERVICES',
  PropertyRelatedConstruction = 'PROPERTY_RELATED_CONSTRUCTION',
  PropertyRelatedServices = 'PROPERTY_RELATED_SERVICES',
  PublicListed = 'PUBLIC_LISTED',
  PublicUtilities = 'PUBLIC_UTILITIES',
  ResearchOrSurvey = 'RESEARCH_OR_SURVEY',
  RetailStores = 'RETAIL_STORES',
  SecurityEscort = 'SECURITY_ESCORT',
  SecurityOrFire = 'SECURITY_OR_FIRE',
  Sme = 'SME',
  Sport = 'SPORT',
  Telecommunication = 'TELECOMMUNICATION',
  Tourism = 'TOURISM',
  TravelAgencies = 'TRAVEL_AGENCIES',
  UniformedGroup = 'UNIFORMED_GROUP',
  WarehousingPackaging = 'WAREHOUSING_PACKAGING'
}

export enum InsureMoRegion {
  Asean = 'ASEAN',
  AsiaPacific = 'ASIA_PACIFIC',
  Worldwide = 'WORLDWIDE',
  WorldwideExcludingUsa = 'WORLDWIDE_EXCLUDING_USA'
}

export enum Language {
  En = 'EN',
  Zh = 'ZH'
}

export enum LinkClass {
  External = 'EXTERNAL',
  Internal = 'INTERNAL'
}

export enum LoanPurpose {
  CarLoan = 'CAR_LOAN',
  DebtConsolidation = 'DEBT_CONSOLIDATION',
  Education = 'EDUCATION',
  Holiday = 'HOLIDAY',
  HomeDecoration = 'HOME_DECORATION',
  InvestmentPurposes = 'INVESTMENT_PURPOSES',
  MedicalBills = 'MEDICAL_BILLS',
  MortgageRepayments = 'MORTGAGE_REPAYMENTS',
  Wedding = 'WEDDING'
}

export enum LoanTimeUnit {
  Month = 'MONTH',
  Year = 'YEAR'
}

export enum LoginState {
  LoggedIn = 'LOGGED_IN',
  NotLoggedIn = 'NOT_LOGGED_IN'
}

export enum MaritalStatus {
  DivorcedOrSeparated = 'DIVORCED_OR_SEPARATED',
  Married = 'MARRIED',
  Other = 'OTHER',
  Single = 'SINGLE',
  Widowed = 'WIDOWED'
}

/** List of Market */
export enum Market {
  Hk = 'HK',
  Sg = 'SG'
}

export enum MiniProductHighlightBadgeColorEnum {
  Blue = 'BLUE',
  Green = 'GREEN',
  Orange = 'ORANGE',
  Red = 'RED',
  Yellow = 'YELLOW'
}

export enum MortgageType {
  NewmortgageRefinance = 'NEWMORTGAGE_REFINANCE',
  Secondmortgage = 'SECONDMORTGAGE'
}

export enum NavigationItemTypeEnum {
  Article = 'ARTICLE',
  ExternalLink = 'EXTERNAL_LINK',
  Page = 'PAGE'
}

export enum NestedContentBackgroundColorEnum {
  Grey = 'GREY',
  PrimaryLight = 'PRIMARY_LIGHT',
  White = 'WHITE'
}

export enum NumberOfDependencies {
  AboveFour = 'ABOVE_FOUR',
  Four = 'FOUR',
  One = 'ONE',
  Three = 'THREE',
  Two = 'TWO',
  Zero = 'ZERO'
}

export enum Occupation {
  Accountant = 'ACCOUNTANT',
  AccountAssistant = 'ACCOUNT_ASSISTANT',
  Activities = 'ACTIVITIES',
  AdminSupportClerical = 'ADMIN_SUPPORT_CLERICAL',
  AdminSupportExecutive = 'ADMIN_SUPPORT_EXECUTIVE',
  AdvertisingMarketingExecutive = 'ADVERTISING_MARKETING_EXECUTIVE',
  AgricultureOwner = 'AGRICULTURE_OWNER',
  AgriculturePersonnel = 'AGRICULTURE_PERSONNEL',
  AirforceOfficer = 'AIRFORCE_OFFICER',
  AirforcePersonnel = 'AIRFORCE_PERSONNEL',
  AirStewardEss = 'AIR_STEWARD_ESS',
  Analyst = 'ANALYST',
  AnimalGroomerTrainer = 'ANIMAL_GROOMER_TRAINER',
  Architect = 'ARCHITECT',
  ArchitectualPartnerOwner = 'ARCHITECTUAL_PARTNER_OWNER',
  ArmyOfficer = 'ARMY_OFFICER',
  ArmyPersonnel = 'ARMY_PERSONNEL',
  ArtsAntiqueDealer = 'ARTS_ANTIQUE_DEALER',
  ArtsEntmtArtist = 'ARTS_ENTMT_ARTIST',
  AssistantManager = 'ASSISTANT_MANAGER',
  Auctioneer = 'AUCTIONEER',
  Auditor = 'AUDITOR',
  AutoSparePartsDealerManufacturer = 'AUTO_SPARE_PARTS_DEALER_MANUFACTURER',
  ACFirmPartnerOwner = 'A_C_FIRM_PARTNER_OWNER',
  Baker = 'BAKER',
  Banker = 'BANKER',
  BankingFinanceExecutive = 'BANKING_FINANCE_EXECUTIVE',
  Barrister = 'BARRISTER',
  BeauticianFashion = 'BEAUTICIAN_FASHION',
  BeauticianOwner = 'BEAUTICIAN_OWNER',
  BioChemist = 'BIO_CHEMIST',
  BrokerRmisierDlr = 'BROKER_RMISIER_DLR',
  BusinessOwnerBuildingConstr = 'BUSINESS_OWNER_BUILDING_CONSTR',
  CallCenterServiceOperator = 'CALL_CENTER_SERVICE_OPERATOR',
  CarBoatPlaneDealer = 'CAR_BOAT_PLANE_DEALER',
  Cashier = 'CASHIER',
  CashIntensiveBusinessesOwner = 'CASH_INTENSIVE_BUSINESSES_OWNER',
  CasinoGamingOperatorOwner = 'CASINO_GAMING_OPERATOR_OWNER',
  Caterer = 'CATERER',
  Ceo = 'CEO',
  Chairman = 'CHAIRMAN',
  CheckCashingOwner = 'CHECK_CASHING_OWNER',
  Chef = 'CHEF',
  Chemist = 'CHEMIST',
  CivilEngineer = 'CIVIL_ENGINEER',
  CivilServantGovernment = 'CIVIL_SERVANT_GOVERNMENT',
  CivilServiceJunior = 'CIVIL_SERVICE_JUNIOR',
  CivilServiceMiddle = 'CIVIL_SERVICE_MIDDLE',
  CivilServiceSenior = 'CIVIL_SERVICE_SENIOR',
  Clerical = 'CLERICAL',
  ClericalOfficer = 'CLERICAL_OFFICER',
  CommunitySocialSvePersonnel = 'COMMUNITY_SOCIAL_SVE_PERSONNEL',
  ComputerAnalyst = 'COMPUTER_ANALYST',
  ComputerEngineer = 'COMPUTER_ENGINEER',
  ComputerOperator = 'COMPUTER_OPERATOR',
  ConstructionWorker = 'CONSTRUCTION_WORKER',
  ConsultancyServiceExecutive = 'CONSULTANCY_SERVICE_EXECUTIVE',
  ConsultancyServicePartnerOwner = 'CONSULTANCY_SERVICE_PARTNER_OWNER',
  Consultant = 'CONSULTANT',
  ContractorBuilding = 'CONTRACTOR_BUILDING',
  CorrectionalServices = 'CORRECTIONAL_SERVICES',
  CostumeJewelleryExporter = 'COSTUME_JEWELLERY_EXPORTER',
  CountryChiefExecutiveOfficer = 'COUNTRY_CHIEF_EXECUTIVE_OFFICER',
  CurrencyExchangeOwner = 'CURRENCY_EXCHANGE_OWNER',
  CustomerServicePersonnel = 'CUSTOMER_SERVICE_PERSONNEL',
  DentistMedical = 'DENTIST_MEDICAL',
  Designer = 'DESIGNER',
  DesignerFashionAndBeauty = 'DESIGNER_FASHION_AND_BEAUTY',
  DespatchDelivery = 'DESPATCH_DELIVERY',
  Diplomat = 'DIPLOMAT',
  Director = 'DIRECTOR',
  DoctorMedical = 'DOCTOR_MEDICAL',
  DomesticHelper = 'DOMESTIC_HELPER',
  DotComCompanySeniorManagement = 'DOT_COM_COMPANY_SENIOR_MANAGEMENT',
  DriverTransport = 'DRIVER_TRANSPORT',
  DrivingInstructor = 'DRIVING_INSTRUCTOR',
  Editor = 'EDITOR',
  Electrician = 'ELECTRICIAN',
  EmploymentAgencyExecutive = 'EMPLOYMENT_AGENCY_EXECUTIVE',
  EmploymentAgencyOwner = 'EMPLOYMENT_AGENCY_OWNER',
  Engineer = 'ENGINEER',
  EngineerAssistant = 'ENGINEER_ASSISTANT',
  Executive = 'EXECUTIVE',
  ExecutiveBuildingConstr = 'EXECUTIVE_BUILDING_CONSTR',
  FinancialAnalyst = 'FINANCIAL_ANALYST',
  FinancialController = 'FINANCIAL_CONTROLLER',
  Fireman = 'FIREMAN',
  FisheryOwner = 'FISHERY_OWNER',
  FisheryPersonnel = 'FISHERY_PERSONNEL',
  FlightEngrCaptainAirline = 'FLIGHT_ENGR_CAPTAIN_AIRLINE',
  FundManager = 'FUND_MANAGER',
  FAndBFastFoodBusinessOwner = 'F_AND_B_FAST_FOOD_BUSINESS_OWNER',
  FAndBRestaurantBusinessOwner = 'F_AND_B_RESTAURANT_BUSINESS_OWNER',
  FAndBRestaurantManager = 'F_AND_B_RESTAURANT_MANAGER',
  GeneralManager = 'GENERAL_MANAGER',
  GoldsmithEmployee = 'GOLDSMITH_EMPLOYEE',
  GoldsmithOwner = 'GOLDSMITH_OWNER',
  GovernmentPolitical = 'GOVERNMENT_POLITICAL',
  HairdresserFashionAndBeauty = 'HAIRDRESSER_FASHION_AND_BEAUTY',
  HawkerFAndB = 'HAWKER_F_AND_B',
  HealthcarePersonnel = 'HEALTHCARE_PERSONNEL',
  HealthcareSpecialist = 'HEALTHCARE_SPECIALIST',
  HospitalityGeneralManagement = 'HOSPITALITY_GENERAL_MANAGEMENT',
  HospitalityOwner = 'HOSPITALITY_OWNER',
  HospitalityServicePersonnel = 'HOSPITALITY_SERVICE_PERSONNEL',
  Hostess = 'HOSTESS',
  HotelStaff = 'HOTEL_STAFF',
  HumanResourceExecutive = 'HUMAN_RESOURCE_EXECUTIVE',
  ImmigrationCustomServices = 'IMMIGRATION_CUSTOM_SERVICES',
  ImportAndExportBusinessOwner = 'IMPORT_AND_EXPORT_BUSINESS_OWNER',
  ImportAndExportStaff = 'IMPORT_AND_EXPORT_STAFF',
  InformationTechnology = 'INFORMATION_TECHNOLOGY',
  InsuranceAgent = 'INSURANCE_AGENT',
  InteriorDesignerDecorator = 'INTERIOR_DESIGNER_DECORATOR',
  ItComputerHardware = 'IT_COMPUTER_HARDWARE',
  ItComputerSoftware = 'IT_COMPUTER_SOFTWARE',
  ItInfoSystemOfficer = 'IT_INFO_SYSTEM_OFFICER',
  Jeweller = 'JEWELLER',
  JewelleryGemCraftman = 'JEWELLERY_GEM_CRAFTMAN',
  JewelGemPreciousMetelsDealers = 'JEWEL_GEM_PRECIOUS_METELS_DEALERS',
  Jockey = 'JOCKEY',
  Journalist = 'JOURNALIST',
  JudgeLegal = 'JUDGE_LEGAL',
  JudicialOfficerLegal = 'JUDICIAL_OFFICER_LEGAL',
  JuniorExecutive = 'JUNIOR_EXECUTIVE',
  JunketOperator = 'JUNKET_OPERATOR',
  LawyerLegal = 'LAWYER_LEGAL',
  LawFirmPartnerOwner = 'LAW_FIRM_PARTNER_OWNER',
  LawFirmSolePractitioner = 'LAW_FIRM_SOLE_PRACTITIONER',
  LeatherGoodStoreBizOwner = 'LEATHER_GOOD_STORE_BIZ_OWNER',
  LecturerEducation = 'LECTURER_EDUCATION',
  LegalSecretary = 'LEGAL_SECRETARY',
  Librarian = 'LIBRARIAN',
  MachinePartManufacturerDealer = 'MACHINE_PART_MANUFACTURER_DEALER',
  Maid = 'MAID',
  MakeupArtistFashionAndBeauty = 'MAKEUP_ARTIST_FASHION_AND_BEAUTY',
  Manager = 'MANAGER',
  ManicuristFashionAndBeauty = 'MANICURIST_FASHION_AND_BEAUTY',
  ManufacturingProductionExecutive = 'MANUFACTURING_PRODUCTION_EXECUTIVE',
  ManufacturingProductionOperator = 'MANUFACTURING_PRODUCTION_OPERATOR',
  ManufacturingProdBusinessOwner = 'MANUFACTURING_PROD_BUSINESS_OWNER',
  MarketingSalesExecutive = 'MARKETING_SALES_EXECUTIVE',
  Mechanic = 'MECHANIC',
  MediaIndustryPersonnel = 'MEDIA_INDUSTRY_PERSONNEL',
  MemberOfParliament = 'MEMBER_OF_PARLIAMENT',
  MiddleExecutive = 'MIDDLE_EXECUTIVE',
  MinisterGovernment = 'MINISTER_GOVERNMENT',
  MiniMartShopOwner = 'MINI_MART_SHOP_OWNER',
  ModelFashionAndBeauty = 'MODEL_FASHION_AND_BEAUTY',
  MoneyBrokerOwner = 'MONEY_BROKER_OWNER',
  MoneyChangerOwner = 'MONEY_CHANGER_OWNER',
  MoneyManagerSolePractitioner = 'MONEY_MANAGER_SOLE_PRACTITIONER',
  MoneyTransmitterOwner = 'MONEY_TRANSMITTER_OWNER',
  MonkNun = 'MONK_NUN',
  MovieTheatreOwner = 'MOVIE_THEATRE_OWNER',
  MusicTeacher = 'MUSIC_TEACHER',
  NationalServiceman = 'NATIONAL_SERVICEMAN',
  NavyOfficer = 'NAVY_OFFICER',
  NavyPersonnel = 'NAVY_PERSONNEL',
  NonProfitOrganisationStaff = 'NON_PROFIT_ORGANISATION_STAFF',
  NonProfitOrgMgmt = 'NON_PROFIT_ORG_MGMT',
  NotaryPartnerOwner = 'NOTARY_PARTNER_OWNER',
  NovelistAuthor = 'NOVELIST_AUTHOR',
  NurseMedical = 'NURSE_MEDICAL',
  Nutritionist = 'NUTRITIONIST',
  Officer = 'OFFICER',
  OffshoreCorporationSetup = 'OFFSHORE_CORPORATION_SETUP',
  Optician = 'OPTICIAN',
  Others = 'OTHERS',
  Painter = 'PAINTER',
  ParkingGarageOwner = 'PARKING_GARAGE_OWNER',
  Partner = 'PARTNER',
  Pastor = 'PASTOR',
  PawnShopBusinessOwner = 'PAWN_SHOP_BUSINESS_OWNER',
  PawnShopPersonnel = 'PAWN_SHOP_PERSONNEL',
  PharmaceuticalPersonnel = 'PHARMACEUTICAL_PERSONNEL',
  PhoneCardBusinessOwner = 'PHONE_CARD_BUSINESS_OWNER',
  PhoneCenterBusinessOwner = 'PHONE_CENTER_BUSINESS_OWNER',
  PhotographerCamerman = 'PHOTOGRAPHER_CAMERMAN',
  Physician = 'PHYSICIAN',
  Physiotherapist = 'PHYSIOTHERAPIST',
  Pilot = 'PILOT',
  Plumber = 'PLUMBER',
  Policeman = 'POLICEMAN',
  PoliceInspector = 'POLICE_INSPECTOR',
  PoliticianGovernment = 'POLITICIAN_GOVERNMENT',
  Postman = 'POSTMAN',
  President = 'PRESIDENT',
  PrincipalDeanEducation = 'PRINCIPAL_DEAN_EDUCATION',
  PrintingPublishingExecutive = 'PRINTING_PUBLISHING_EXECUTIVE',
  PrintingPublishingOwner = 'PRINTING_PUBLISHING_OWNER',
  PrintingPublishingPersonnel = 'PRINTING_PUBLISHING_PERSONNEL',
  PrisonWarden = 'PRISON_WARDEN',
  PrivateInvestigator = 'PRIVATE_INVESTIGATOR',
  PrivateTutorEducation = 'PRIVATE_TUTOR_EDUCATION',
  ProductionWorker = 'PRODUCTION_WORKER_',
  ProfessionalOthers = 'PROFESSIONAL_OTHERS',
  ProfessionalSportsperson = 'PROFESSIONAL_SPORTSPERSON',
  ProfessorEducation = 'PROFESSOR_EDUCATION',
  ProfessorMedical = 'PROFESSOR_MEDICAL',
  Programmer = 'PROGRAMMER',
  PropertyPersonnelExecutive = 'PROPERTY_PERSONNEL_EXECUTIVE',
  ProprietorPartnership = 'PROPRIETOR_PARTNERSHIP',
  Psychiatrist = 'PSYCHIATRIST',
  PublicRelationExecutive = 'PUBLIC_RELATION_EXECUTIVE',
  PubLoungeDiscoOwner = 'PUB_LOUNGE_DISCO_OWNER',
  PubLoungeDiscoPersonnel = 'PUB_LOUNGE_DISCO_PERSONNEL',
  PurchasingOfficer = 'PURCHASING_OFFICER',
  QualityControlPersonnel = 'QUALITY_CONTROL_PERSONNEL',
  RealEstateBroker = 'REAL_ESTATE_BROKER',
  RealEstateOwner = 'REAL_ESTATE_OWNER',
  RemittancesServicesOwner = 'REMITTANCES_SERVICES_OWNER',
  Researcher = 'RESEARCHER',
  RetailBusinessOwner = 'RETAIL_BUSINESS_OWNER',
  RetailMerchandiser = 'RETAIL_MERCHANDISER',
  RetiredPerson = 'RETIRED_PERSON',
  SalesCommission = 'SALES_COMMISSION',
  SalesManager = 'SALES_MANAGER',
  SalesSalaried = 'SALES__SALARIED',
  Scientist = 'SCIENTIST',
  SeamanSailor = 'SEAMAN_SAILOR',
  SecretarialFirmPartnerOwner = 'SECRETARIAL_FIRM_PARTNER_OWNER',
  Secretary = 'SECRETARY',
  SecurityGuard = 'SECURITY_GUARD',
  SelfEmployed = 'SELF_EMPLOYED',
  SeniorExecutive = 'SENIOR_EXECUTIVE',
  ShippingBusinessOwner = 'SHIPPING_BUSINESS_OWNER',
  ShippingExecutive = 'SHIPPING_EXECUTIVE',
  ShippingPersonnel = 'SHIPPING_PERSONNEL',
  ShopAssistant = 'SHOP_ASSISTANT',
  SkilledWorker = 'SKILLED_WORKER',
  SoleProprietor = 'SOLE_PROPRIETOR',
  Specialist = 'SPECIALIST',
  SpecialistMedical = 'SPECIALIST_MEDICAL',
  StockBroker = 'STOCK_BROKER',
  Subcontractor = 'SUBCONTRACTOR',
  Supervisor = 'SUPERVISOR',
  SurgeonMedical = 'SURGEON_MEDICAL',
  Surveyor = 'SURVEYOR',
  SwimmingSportsInstructor = 'SWIMMING_SPORTS_INSTRUCTOR',
  SystemAnalyst = 'SYSTEM_ANALYST',
  TailorSeamstress = 'TAILOR_SEAMSTRESS',
  TaxHavensSeniorManagement = 'TAX_HAVENS_SENIOR_MANAGEMENT',
  TeacherEducation = 'TEACHER_EDUCATION',
  Technician = 'TECHNICIAN',
  TelecommunicationExecutive = 'TELECOMMUNICATION_EXECUTIVE',
  TelecommunicationPersonnel = 'TELECOMMUNICATION_PERSONNEL',
  TelemarketersOwners = 'TELEMARKETERS_OWNERS',
  TextileBusinessOwners = 'TEXTILE_BUSINESS_OWNERS',
  TourismTravelAgencyExecutive = 'TOURISM_TRAVEL_AGENCY_EXECUTIVE',
  TourismTravelAgencyOwner = 'TOURISM_TRAVEL_AGENCY_OWNER',
  TourGuideTourism = 'TOUR_GUIDE_TOURISM',
  TransportWorker = 'TRANSPORT_WORKER',
  Typist = 'TYPIST',
  Underwriter = 'UNDERWRITER',
  Unemployed = 'UNEMPLOYED',
  UsedTruckManufacturerDealer = 'USED_TRUCK_MANUFACTURER_DEALER',
  Valuer = 'VALUER',
  VentureCaptitalCompanySeniorMgmt = 'VENTURE_CAPTITAL_COMPANY_SENIOR_MGMT',
  Veterinarian = 'VETERINARIAN',
  WaiterWaitressFAndB = 'WAITER_WAITRESS_F_AND_B',
  WarehousingInventoryOwner = 'WAREHOUSING_INVENTORY_OWNER',
  WarehousingInventoryPersonnel = 'WAREHOUSING_INVENTORY_PERSONNEL',
  WholesalerRetailerOfElectronics = 'WHOLESALER_RETAILER_OF_ELECTRONICS',
  Worker = 'WORKER'
}

export enum OrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DateModifiedDesc = 'DATE_MODIFIED_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export enum OrderTableItemComponentColumnEnum {
  AnnualInterestRate = 'ANNUAL_INTEREST_RATE',
  ApplyButton = 'APPLY_BUTTON',
  ApprovalOdds = 'APPROVAL_ODDS',
  BankLogo = 'BANK_LOGO',
  EffectiveInterestRate = 'EFFECTIVE_INTEREST_RATE',
  GoogleRatings = 'GOOGLE_RATINGS',
  HandlingFee = 'HANDLING_FEE',
  HottestReward = 'HOTTEST_REWARD',
  InterestRate = 'INTEREST_RATE',
  IntroductoryAnnualRate = 'INTRODUCTORY_ANNUAL_RATE',
  IntroductoryMonthlyRepayment = 'INTRODUCTORY_MONTHLY_REPAYMENT',
  MaximumLoanAmount = 'MAXIMUM_LOAN_AMOUNT',
  MonthlyRepayment = 'MONTHLY_REPAYMENT',
  ProductName = 'PRODUCT_NAME',
  RewardValue = 'REWARD_VALUE',
  TotalInterestPayable = 'TOTAL_INTEREST_PAYABLE',
  WhyApplyNow = 'WHY_APPLY_NOW'
}

export enum PageConfigContext {
  Application = 'APPLICATION',
  Default = 'DEFAULT'
}

export enum PageLayoutEnum {
  CategoryLanding = 'CATEGORY_LANDING',
  CheckRatePersonalLoan = 'CHECK_RATE_PERSONAL_LOAN',
  GuidesLayout = 'GUIDES_LAYOUT',
  Standart = 'STANDART',
  VerticalLanding = 'VERTICAL_LANDING'
}

export enum PageRelevantArticleTypeEnum {
  Big = 'BIG',
  Normal = 'NORMAL'
}

export enum PaymentFeedback {
  AlreadyProcessed = 'ALREADY_PROCESSED',
  Expired = 'EXPIRED',
  Ok = 'OK'
}

export enum PaymentMethod {
  Auto = 'AUTO',
  Cash = 'CASH',
  Cheque = 'CHEQUE'
}

export enum PdpSectionSlotEnum {
  EligibilityApply = 'ELIGIBILITY_APPLY',
  FeaturesPlatform = 'FEATURES_PLATFORM',
  Highlights = 'HIGHLIGHTS',
  Offers = 'OFFERS',
  RatesFees = 'RATES_FEES'
}

/** Interval used for fee or interest calculations. */
export enum PersonalLoanRateInterval {
  Annually = 'ANNUALLY',
  Monthly = 'MONTHLY'
}

export enum PlCalculatorPrefixEnum {
  Hk = 'HK',
  Nt = 'NT',
  P = 'P',
  S = 'S'
}

export enum PlCalculatorRepaymentPeriodEnum {
  Month_6 = 'MONTH_6',
  Month_12 = 'MONTH_12',
  Month_18 = 'MONTH_18',
  Month_24 = 'MONTH_24',
  Month_30 = 'MONTH_30',
  Month_36 = 'MONTH_36',
  Month_48 = 'MONTH_48',
  Month_60 = 'MONTH_60',
  Month_72 = 'MONTH_72',
  Month_84 = 'MONTH_84',
  Month_96 = 'MONTH_96'
}

export enum PlSortOptionValueEnum {
  AnnualRate = 'ANNUAL_RATE',
  Eir = 'EIR',
  LoanTenure = 'LOAN_TENURE',
  MonthlyRepayment = 'MONTHLY_REPAYMENT',
  Popular = 'POPULAR',
  TotalRepayment = 'TOTAL_REPAYMENT'
}

export enum PolicyStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  ContactSupport = 'CONTACT_SUPPORT',
  Expired = 'EXPIRED',
  Expiring = 'EXPIRING',
  PendingIssuance = 'PENDING_ISSUANCE',
  Upcoming = 'UPCOMING'
}

export enum PolicySummaryFieldKeyEnum {
  AddOns = 'ADD_ONS',
  BuiltUpArea = 'BUILT_UP_AREA',
  CoverType = 'COVER_TYPE',
  Destination = 'DESTINATION',
  DiscountPct = 'DISCOUNT_PCT',
  EndDate = 'END_DATE',
  Premium = 'PREMIUM',
  RefNo = 'REF_NO',
  StartDate = 'START_DATE',
  Travellers = 'TRAVELLERS'
}

export enum PreferredSourceButtonThemeEnum {
  Auto = 'AUTO',
  Dark = 'DARK',
  Light = 'LIGHT'
}

export enum PriceSortDirectionEnum {
  HighToLow = 'HIGH_TO_LOW',
  LowToHigh = 'LOW_TO_HIGH'
}

export enum PriceSourceEnum {
  LivePremium = 'LIVE_PREMIUM',
  StaticPrice = 'STATIC_PRICE'
}

export enum ProductBlockColorTagEnum {
  Blue = 'BLUE',
  Gold = 'GOLD',
  Gray = 'GRAY',
  Green = 'GREEN',
  Orange = 'ORANGE',
  Purple = 'PURPLE',
  Red = 'RED',
  Yellow = 'YELLOW'
}

export enum ProductCardGridLayoutTypeEnum {
  Carousel = 'CAROUSEL',
  Grid = 'GRID'
}

export enum ProductCardGridRewardToggleColourEnum {
  Blue = 'BLUE',
  Yellow = 'YELLOW'
}

export enum ProductDetailsBenefitCategorySelectorEnum {
  Airmiles = 'AIRMILES',
  Cashback = 'CASHBACK',
  Empty = 'EMPTY',
  RewardsPoints = 'REWARDS_POINTS'
}

export enum ProductDetailsRenderingModeEnum {
  FullPage = 'FULL_PAGE',
  Modal = 'MODAL',
  TiProvider = 'TI_PROVIDER'
}

export enum PropertyType {
  HosWithoutLandPremium = 'HOS_WITHOUT_LAND_PREMIUM',
  HosWithLandPremium = 'HOS_WITH_LAND_PREMIUM',
  NewlyDevelopedHousing = 'NEWLY_DEVELOPED_HOUSING',
  PrivateHousing = 'PRIVATE_HOUSING',
  VillageHouse = 'VILLAGE_HOUSE'
}

export enum QueryType {
  AllAttributeTypes = 'ALL_ATTRIBUTE_TYPES',
  AllCategoryIdentifiers = 'ALL_CATEGORY_IDENTIFIERS',
  AllCriteriaAttributeTypes = 'ALL_CRITERIA_ATTRIBUTE_TYPES',
  AllExclusiveOffers = 'ALL_EXCLUSIVE_OFFERS',
  AllFaqs = 'ALL_FAQS',
  AllLeadFieldDefinitions = 'ALL_LEAD_FIELD_DEFINITIONS',
  AllProducts = 'ALL_PRODUCTS',
  AllProviders = 'ALL_PROVIDERS',
  AllUrlIdentifiers = 'ALL_URL_IDENTIFIERS',
  AllWelcomeOffers = 'ALL_WELCOME_OFFERS'
}

export enum QuestionSelectionType {
  Multiple = 'MULTIPLE',
  Single = 'SINGLE'
}

export enum QuickAnswerDisplayModeEnum {
  ProductComparison = 'PRODUCT_COMPARISON',
  Summary = 'SUMMARY'
}

export enum QuizSubmissionStatus {
  Rejected = 'REJECTED',
  Successful = 'SUCCESSFUL'
}

export enum RawJsonType {
  SysAssets = 'sys_assets'
}

export enum RecomendedForTypeEnum {
  CheckboxGreen = 'CHECKBOX_GREEN',
  RedCross = 'RED_CROSS'
}

export enum RecommendationType {
  Article = 'ARTICLE',
  Promotion = 'PROMOTION'
}

/** List of reference data enum */
export enum ReferenceDataType {
  Cities = 'CITIES',
  CountryCodes = 'COUNTRY_CODES',
  Eligibility = 'ELIGIBILITY',
  Financiers = 'FINANCIERS',
  Genders = 'GENDERS',
  IdentificationTypes = 'IDENTIFICATION_TYPES',
  MaritalStatuses = 'MARITAL_STATUSES',
  MotorCoverageTypes = 'MOTOR_COVERAGE_TYPES',
  NationalityCodes = 'NATIONALITY_CODES',
  OccupationCodes = 'OCCUPATION_CODES',
  OccupationTypes = 'OCCUPATION_TYPES',
  RaceCodes = 'RACE_CODES',
  RelationsWithPolicyholder = 'RELATIONS_WITH_POLICYHOLDER',
  States = 'STATES',
  Title = 'TITLE',
  TravelCountries = 'TRAVEL_COUNTRIES',
  TravelCoverTypes = 'TRAVEL_COVER_TYPES',
  TravelDurations = 'TRAVEL_DURATIONS',
  TravelPlanCode = 'TRAVEL_PLAN_CODE',
  TravelPlanTypes = 'TRAVEL_PLAN_TYPES',
  TravelRegions = 'TRAVEL_REGIONS',
  Unknown = 'UNKNOWN',
  VehicleUsages = 'VEHICLE_USAGES'
}

export enum Region {
  AsiaPacific = 'ASIA_PACIFIC',
  Worldwide = 'WORLDWIDE',
  WorldwideExcludingUsa = 'WORLDWIDE_EXCLUDING_USA'
}

/** List of Relationship */
export enum RelationWithPolicyholder {
  Chld = 'CHLD',
  Clg = 'CLG',
  Empl = 'EMPL',
  Emplr = 'EMPLR',
  Frnd = 'FRND',
  Oth = 'OTH',
  Prnt = 'PRNT',
  Rel = 'REL',
  Sblng = 'SBLNG',
  Slf = 'SLF',
  Sp = 'SP'
}

export enum Relationship {
  Child = 'CHILD',
  Companion = 'COMPANION',
  Self = 'SELF',
  Spouse = 'SPOUSE'
}

export enum RelevantArticleGroupTypeEnum {
  CompareProducts = 'COMPARE_PRODUCTS',
  LearnMore = 'LEARN_MORE',
  RelatedGuides = 'RELATED_GUIDES'
}

export enum RelevantArticleModeEnum {
  GroupedNavigation = 'GROUPED_NAVIGATION',
  Standard = 'STANDARD'
}

export enum RelevantArticleTypeEnum {
  External = 'EXTERNAL',
  InternalArticle = 'INTERNAL_ARTICLE',
  InternalPage = 'INTERNAL_PAGE'
}

export enum ResidenceType {
  Bungalow = 'BUNGALOW',
  Condominium = 'CONDOMINIUM',
  HdbExecutive = 'HDB_EXECUTIVE',
  HdbFlat = 'HDB_FLAT',
  HudcFlat = 'HUDC_FLAT',
  PrivateApartment = 'PRIVATE_APARTMENT',
  SemiDetachedHouse = 'SEMI_DETACHED_HOUSE',
  ServiceApartment = 'SERVICE_APARTMENT',
  ShopHouse = 'SHOP_HOUSE',
  TerraceHouse = 'TERRACE_HOUSE'
}

export enum ResidencyStatus {
  Citizen = 'CITIZEN',
  Foreigner = 'FOREIGNER',
  PermanentResident = 'PERMANENT_RESIDENT'
}

export enum ResidentialStatus {
  OtherResidentialStatus = 'OTHER_RESIDENTIAL_STATUS',
  OwnedOrRentedByRelatives = 'OWNED_OR_RENTED_BY_RELATIVES',
  QuartersOrCompanyProvided = 'QUARTERS_OR_COMPANY_PROVIDED',
  SelfOwnedWithoutMortgage = 'SELF_OWNED_WITHOUT_MORTGAGE',
  SelfOwnedWithMortgage = 'SELF_OWNED_WITH_MORTGAGE',
  SelfRented = 'SELF_RENTED'
}

export enum ResultsPageType {
  Funnel = 'FUNNEL',
  Success = 'SUCCESS'
}

export enum RewardButtonStyle {
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY',
  Tertiary = 'TERTIARY'
}

export enum RewardCardGridLayoutTypeEnum {
  Carousel = 'CAROUSEL',
  Grid = 'GRID'
}

/** rewards email type */
export enum RewardEmailType {
  EmailSubmission = 'EMAIL_SUBMISSION',
  RedemptionSubmission = 'REDEMPTION_SUBMISSION'
}

/** lead state option */
export enum RewardLeadState {
  ConfirmationPage = 'CONFIRMATION_PAGE',
  ReservePage = 'RESERVE_PAGE',
  Signup = 'SIGNUP',
  StartApplicationPage = 'START_APPLICATION_PAGE',
  Submitted = 'SUBMITTED'
}

export enum RewardStage {
  Collected = 'COLLECTED',
  Consumed = 'CONSUMED',
  Denied = 'DENIED',
  Disabled = 'DISABLED',
  Error = 'ERROR',
  Expired = 'EXPIRED',
  Finished = 'FINISHED',
  Fulfilled = 'FULFILLED',
  Preregistration = 'PREREGISTRATION',
  Registered = 'REGISTERED',
  ToFulfill = 'TO_FULFILL',
  Verified = 'VERIFIED'
}

export enum RewardStatusLevel {
  Danger = 'DANGER',
  Normal = 'NORMAL',
  Warning = 'WARNING'
}

export enum SecondaryCtaColorSchemeEnum {
  Blue = 'BLUE',
  Green = 'GREEN',
  Orange = 'ORANGE',
  Red = 'RED',
  White = 'WHITE',
  Yellow = 'YELLOW'
}

export enum SectionalHeaderComponentLevelEnum {
  H2 = 'H2',
  H3 = 'H3',
  H4 = 'H4',
  H5 = 'H5',
  P = 'P'
}

export enum SelectFilterStyle {
  Check = 'Check',
  Multi = 'Multi',
  Range = 'Range',
  Single = 'Single',
  Switch = 'Switch'
}

export enum SelectedProductsDisplayTypeEnum {
  ComparisonTable = 'COMPARISON_TABLE',
  ProductListing = 'PRODUCT_LISTING'
}

export enum SimpleStickyFooterColorSchemaEnum {
  Blue = 'BLUE',
  Green = 'GREEN',
  Orange = 'ORANGE',
  Red = 'RED',
  White = 'WHITE',
  Yellow = 'YELLOW'
}

export enum SingleProductPromotionsBackgroundColorEnum {
  Gradient = 'GRADIENT',
  White = 'WHITE'
}

export enum SortDirectionEnum {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum StandoutTextBlockTypeEnum {
  EditorsPick = 'EDITORS_PICK',
  ExpertPerspective = 'EXPERT_PERSPECTIVE',
  Takeaways = 'TAKEAWAYS',
  Tips = 'TIPS'
}

/** List of Stripe Locale */
export enum StripeLocale {
  Auto = 'AUTO',
  Bg = 'BG',
  Cs = 'CS',
  Da = 'DA',
  De = 'DE',
  El = 'EL',
  En = 'EN',
  EnGb = 'EN_GB',
  Es = 'ES',
  Es_419 = 'ES_419',
  Et = 'ET',
  Fi = 'FI',
  Fil = 'FIL',
  Fr = 'FR',
  FrCa = 'FR_CA',
  Hr = 'HR',
  Hu = 'HU',
  Id = 'ID',
  It = 'IT',
  Ja = 'JA',
  Ko = 'KO',
  Lt = 'LT',
  Lv = 'LV',
  Ms = 'MS',
  Mt = 'MT',
  Nb = 'NB',
  Nl = 'NL',
  Pl = 'PL',
  Pt = 'PT',
  PtBr = 'PT_BR',
  Ro = 'RO',
  Ru = 'RU',
  Sk = 'SK',
  Sl = 'SL',
  Sv = 'SV',
  Th = 'TH',
  Tr = 'TR',
  Vi = 'VI',
  Zh = 'ZH',
  ZhHk = 'ZH_HK',
  ZhTw = 'ZH_TW'
}

/** Subscription State Enum */
export enum SubscriptionState {
  /** A user has explicitly confirmed they want to receive email. We recommend an explicit opt-in process to get consent from users to send emails. */
  OptedIn = 'OPTED_IN',
  /** A user has neither unsubscribed nor explicitly opted-in to receive emails. This is the default subscription state when a user profile is created. */
  Subscribed = 'SUBSCRIBED',
  /** A user has explicitly unsubscribed from your emails. */
  Unsubscribed = 'UNSUBSCRIBED'
}

export enum SummaryProductsListTypeEnum {
  BulletList = 'BULLET_LIST',
  NumberList = 'NUMBER_LIST'
}

export enum SwiperCardsBannerColorSchemeEnum {
  Blue = 'BLUE',
  Green = 'GREEN',
  Orange = 'ORANGE',
  Red = 'RED',
  WhiteBlue = 'WHITE_BLUE',
  WhiteGreen = 'WHITE_GREEN',
  WhiteOrange = 'WHITE_ORANGE',
  WhiteRed = 'WHITE_RED',
  WhiteYellow = 'WHITE_YELLOW',
  Yellow = 'YELLOW'
}

export enum TabTargetEnum {
  NewTab = 'NEW_TAB',
  SameTab = 'SAME_TAB'
}

export enum TableBuilderHeightVariantEnum {
  Compact = 'COMPACT',
  Flexible = 'FLEXIBLE'
}

export enum TableBuilderIdentityCellCtaOverrideDestinationTypeEnum {
  External = 'EXTERNAL'
}

export enum TableBuilderIdentityCellDisplayVariantEnum {
  LogoName = 'LOGO_NAME',
  LogoNameCta = 'LOGO_NAME_CTA',
  NameCta = 'NAME_CTA'
}

export enum TableBuilderModeEnum {
  General = 'GENERAL',
  PersonalLoan = 'PERSONAL_LOAN',
  TravelInsurance = 'TRAVEL_INSURANCE'
}

export enum TableBuilderRowTypeEnum {
  Category = 'CATEGORY',
  Standard = 'STANDARD'
}

export enum TableOfContentsComponentListTypeEnum {
  BulletList = 'BULLET_LIST',
  NumberList = 'NUMBER_LIST'
}

export enum TestimonialsBackgroundColorEnum {
  LightBlue = 'LIGHT_BLUE',
  LightGreen = 'LIGHT_GREEN',
  LightGrey = 'LIGHT_GREY',
  White = 'WHITE'
}

export enum TiSortOptionValueEnum {
  Discount = 'DISCOUNT',
  LossOfBaggageOrPersonalBelonging = 'LOSS_OF_BAGGAGE_OR_PERSONAL_BELONGING',
  OverseasMedicalExpenses = 'OVERSEAS_MEDICAL_EXPENSES',
  Price = 'PRICE',
  Recommended = 'RECOMMENDED',
  TravelCancellation = 'TRAVEL_CANCELLATION'
}

export enum TimePreferredToBeContacted {
  Afternoon = 'AFTERNOON',
  Anytime = 'ANYTIME',
  Evening = 'EVENING',
  Morning = 'MORNING'
}

export enum TitleSizeEnum {
  Heading_1 = 'HEADING_1',
  Heading_2 = 'HEADING_2',
  Heading_3 = 'HEADING_3',
  Heading_4 = 'HEADING_4',
  Heading_5 = 'HEADING_5',
  Heading_6 = 'HEADING_6'
}

export enum TrackedRewardState {
  /** Eligibility confirmed */
  Approved = 'APPROVED',
  /** Eligibility cannot be confirmed / declined by the financial institution */
  Declined = 'DECLINED',
  /** An Appeal Request is raised and pending for verification */
  Disputed = 'DISPUTED',
  /** Claim not yet submitted */
  Draft = 'DRAFT',
  /** An ARN is submitted in more than one redemption form */
  Duplicated = 'DUPLICATED',
  /** The reward wast not claimed */
  Expired = 'EXPIRED',
  /** Ready for redemption */
  Fulfilled = 'FULFILLED',
  /** Pending (no general timeline) */
  Pending = 'PENDING',
  /** The application is pending for customer to provide the approval proof of the financial product */
  PendingProof = 'PENDING_PROOF',
  /** Rewards where successfully claimed */
  Received = 'RECEIVED'
}

export enum TranslationContext {
  Aw = 'AW',
  Ba = 'BA',
  Cc = 'CC',
  Common = 'COMMON',
  Hl = 'HL',
  Login = 'LOGIN',
  Pa = 'PA',
  Pl = 'PL',
  Pr = 'PR',
  Sa = 'SA',
  Ti = 'TI'
}

export enum TravelInsuranceType {
  AnnualPlan = 'ANNUAL_PLAN',
  SinglePlan = 'SINGLE_PLAN'
}

export enum TravelPolicySearchTripTypeEnum {
  AnnualMultiTrip = 'ANNUAL_MULTI_TRIP',
  SingleTrip = 'SINGLE_TRIP'
}

export enum UrlPrefixEnum {
  UseCampaign = 'USE_CAMPAIGN',
  UsePrimaryVertical = 'USE_PRIMARY_VERTICAL'
}

export enum UrlTargetEnum {
  Blank = 'BLANK',
  Parent = 'PARENT',
  Self = 'SELF',
  Top = 'TOP'
}

/** Car usage type */
export enum Usage {
  Commercial = 'COMMERCIAL',
  Other = 'OTHER',
  Private = 'PRIVATE'
}

/** Current lifecycle status of a user account */
export enum UserAccountStatus {
  Blocked = 'BLOCKED',
  Deleted = 'DELETED',
  New = 'NEW',
  Onboarded = 'ONBOARDED',
  Onboarding = 'ONBOARDING',
  Registered = 'REGISTERED'
}

export enum ValueCellFreeTextTypeEnum {
  LongTextExpandCollapse = 'LONG_TEXT_EXPAND_COLLAPSE',
  TextOnly = 'TEXT_ONLY'
}

export enum Vertical {
  Aw = 'AW',
  Ba = 'BA',
  Cc = 'CC',
  Hi = 'HI',
  Hl = 'HL',
  Ip = 'IP',
  Mi = 'MI',
  Ob = 'OB',
  Pa = 'PA',
  Pl = 'PL',
  Pr = 'PR',
  Sa = 'SA',
  Static = 'STATIC',
  Ti = 'TI'
}

export enum VerticalEnum {
  AssetManagement = 'ASSET_MANAGEMENT',
  Banking = 'BANKING',
  CarInsurance = 'CAR_INSURANCE',
  CreditCard = 'CREDIT_CARD',
  EWallet = 'E_WALLET',
  GovernmentServices = 'GOVERNMENT_SERVICES',
  HealthInsurance = 'HEALTH_INSURANCE',
  HomeInsurance = 'HOME_INSURANCE',
  HomeLoan = 'HOME_LOAN',
  Insurance = 'INSURANCE',
  Investments = 'INVESTMENTS',
  Lifestyle = 'LIFESTYLE',
  MaidInsurance = 'MAID_INSURANCE',
  MoneyManagement = 'MONEY_MANAGEMENT',
  Others = 'OTHERS',
  PersonalFinance = 'PERSONAL_FINANCE',
  PersonalLoans = 'PERSONAL_LOANS',
  PetInsurance = 'PET_INSURANCE',
  Sponsored = 'SPONSORED',
  Telco = 'TELCO',
  TravelInsurance = 'TRAVEL_INSURANCE'
}

export enum VideoBlockAspectRatioEnum {
  Ratio_9_16 = 'RATIO_9_16',
  Ratio_16_9 = 'RATIO_16_9'
}

export enum VideoBlockEmbedTypeEnum {
  Instagram = 'INSTAGRAM',
  Youtube = 'YOUTUBE'
}

export enum VoucherStatus {
  /** Voucher is active */
  Active = 'ACTIVE',
  /** Voucher is claimed */
  Claimed = 'CLAIMED',
  /** Voucher is inactive */
  Inactive = 'INACTIVE',
  /** Voucher is redeemed */
  Redeemed = 'REDEEMED'
}

export enum VoucherType {
  /** Cash voucher */
  Cash = 'CASH',
  /** Discount voucher */
  Discount = 'DISCOUNT',
  /** Physical gift voucher */
  Physical = 'PHYSICAL'
}
